import React from 'react';
import { Upload, X } from 'lucide-react';

const LoginLogoEditor = ({ position, positionName, logo, onToggle, onTypeChange, onIconChange, onImageUpload, onRemoveImage, onBackgroundColorChange, onSizeChange }) => {
  return (
    <div className="border border-gray-300 rounded-lg p-4 bg-white">
      <div className="flex items-center justify-between mb-3">
        <h4 className="font-semibold text-gray-800">{positionName} Logo</h4>
        <label className="flex items-center cursor-pointer">
          <input
            type="checkbox"
            checked={logo.enabled}
            onChange={() => onToggle(position)}
            className="mr-2 w-4 h-4"
          />
          <span className="text-sm text-gray-700">Enable</span>
        </label>
      </div>

      {logo.enabled && (
        <div className="space-y-3">
          {/* Type Selector */}
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-2">
              Type
            </label>
            <div className="flex space-x-2">
              <button
                type="button"
                onClick={() => onTypeChange(position, 'emoji')}
                className={`flex-1 px-3 py-2 text-sm rounded-lg border-2 transition-colors ${
                  logo.type === 'emoji'
                    ? 'border-primary-600 bg-primary-50 text-primary-700'
                    : 'border-gray-300 hover:border-gray-400'
                }`}
              >
                Emoji/Text
              </button>
              <button
                type="button"
                onClick={() => onTypeChange(position, 'image')}
                className={`flex-1 px-3 py-2 text-sm rounded-lg border-2 transition-colors ${
                  logo.type === 'image'
                    ? 'border-primary-600 bg-primary-50 text-primary-700'
                    : 'border-gray-300 hover:border-gray-400'
                }`}
              >
                Image
              </button>
            </div>
          </div>

          {/* Emoji Input */}
          {logo.type === 'emoji' && (
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-2">
                Icon
              </label>
              <input
                type="text"
                value={logo.icon}
                onChange={(e) => onIconChange(position, e.target.value.slice(0, 2))}
                className="input w-full text-center text-2xl"
                placeholder="🐕"
                maxLength={2}
              />
            </div>
          )}

          {/* Image Upload */}
          {logo.type === 'image' && (
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-2">
                Image
              </label>
              {logo.image ? (
                <div className="flex items-center space-x-2">
                  <div className="w-16 h-16 bg-gray-100 rounded-lg overflow-hidden border-2 border-gray-300">
                    <img src={logo.image} alt={`${positionName} Logo`} className="w-full h-full object-cover" />
                  </div>
                  <button
                    type="button"
                    onClick={() => onRemoveImage(position)}
                    className="btn bg-red-100 text-red-600 hover:bg-red-200 flex items-center space-x-1 text-sm px-3 py-2"
                  >
                    <X size={14} />
                    <span>Remove</span>
                  </button>
                </div>
              ) : (
                <label className="cursor-pointer inline-flex items-center space-x-2 px-3 py-2 bg-white border-2 border-gray-300 rounded-lg hover:border-primary-500 transition-colors text-sm">
                  <Upload size={16} />
                  <span>Choose Image</span>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => onImageUpload(position, e)}
                    className="hidden"
                  />
                </label>
              )}
            </div>
          )}

          {/* Background Color */}
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-2">
              Background Color
            </label>
            <div className="flex items-center space-x-2">
              <input
                type="color"
                value={logo.backgroundColor}
                onChange={(e) => onBackgroundColorChange(position, e.target.value)}
                className="w-10 h-9 rounded border border-gray-300 cursor-pointer"
              />
              <input
                type="text"
                value={logo.backgroundColor}
                onChange={(e) => onBackgroundColorChange(position, e.target.value)}
                className="input flex-1 font-mono text-xs"
                placeholder="#2563eb"
              />
            </div>
          </div>

          {/* Size Control */}
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-2">
              Size: {logo.size || 48}px
            </label>
            <input
              type="range"
              min="24"
              max="128"
              step="4"
              value={logo.size || 48}
              onChange={(e) => onSizeChange(position, parseInt(e.target.value))}
              className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-primary-600"
            />
            <div className="flex justify-between text-xs text-gray-500 mt-1">
              <span>Small (24px)</span>
              <span>Large (128px)</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginLogoEditor;
